module.exports = __webpack_public_path__ + "static/media/menuUser.3d902bf0.svg";